import styled from "styled-components";

interface IPaymentHeader {
  currentState?: any;
}
export const PaymentHeader = styled.div<IPaymentHeader>`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  margin-bottom: 1rem;
  padding: 1.5rem;

  h2 {
    color: rgba(8, 8, 43, 0.35);
    font-size: 1.2rem;
    font-weight: 700;
  }

  .tab-name {
    ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 600;
    margin-right: 3rem;
  }

  .payment-tabs {
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;
  }

  ${(props) => {
    const currentState = props.currentState;
    let className;
    if (currentState === 0) {
      className = "quotations";
    } else if (currentState === 1) {
      className = "validation-status";
    } else {
      className = "paid";
    }
    return `
      .${className} {
        background: linear-gradient(${props.theme.colors.primaryBlue},${props.theme.colors.primaryBlue}) bottom left/ 20% 2px no-repeat, ${props.theme.colors.backgroundBlue};
      }
    `;
  }}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 2rem;
  width: 90%;
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }
`;

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.disabled ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border: none;
  border-radius: 8px;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }
  .icon-image {
    height: 4rem;
    width: 4rem;
  }
`;

export const PDFButton = styled.a`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.red};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  margin-left: 2rem;
  margin-right: 2rem;
  text-decoration: none;
  width: 34.8rem;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
